// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jAyI","label":"styles_label__1NaO4"};